<div class="flex flex-row justify-between items-center gap-3 m-3">
  <div>
    <h2 (click)="setMode(mode)" class="cursor-pointer">
      <fa-icon icon="face-grin-beam-sweat" class="mr-3"></fa-icon>
      <span *ngIf="showBrand && !isMobile">GameFace</span>
    </h2>
  </div>





  <div *ngIf="user" class="flex flex-row gap-6 items-center">

    <div *ngIf="canTeach">
      <a [matMenuTriggerFor]="modeMenu">
        {{mode}}
        <fa-icon icon="caret-down" class="ml-1"></fa-icon>
      </a>
      <mat-menu #modeMenu="matMenu">
        <button mat-menu-item (click)="setMode('Student')">Student</button>
        <button mat-menu-item (click)="setMode('Teacher')">Teacher</button>
      </mat-menu>
    </div>

    <a [matMenuTriggerFor]="userMenu" class="cursor-pointer flex flex-row items-center gap-1">
      <app-avatar [user]="user" size="sm" ></app-avatar>
      <fa-icon icon="caret-down"></fa-icon>
    </a>

    <mat-menu #userMenu="matMenu">
      <a mat-menu-item (click)="editProfile()">Edit profile</a>
      <button mat-menu-item (click)="signOut()">Sign out</button>
    </mat-menu>

  </div>


  <div *ngIf="!authenticating && !user" class="flex flex-row gap-3">
    <a mat-button color='primary' routerLink="signin">Sign In</a>
    <a mat-button color='primary' routerLink="signup">Sign Up</a>
  </div>
</div>
